import type React from 'react';
import { observer } from 'mobx-react';
import { Box, Columns, Column, Stack } from 'braid-design-system';
import SortOrderDropdown from '../SortOrderDropdown';
import * as styles from './MobileFilterSection.css';
import { SortOrderDropdownTrigger } from '../SortOrderDropdown/SortOrderDropdownTrigger';
import { FilterActionButton } from './FilterActionButton';
import { FilterButton } from './FilterButton';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';

export interface MobileFilterSectionProps {
  sortBy: string;
  hasSearchText: boolean;
  hasQuestion: boolean;
  onSortByChange: (params: { sortBy: string }) => Promise<void>;
  selectedFilterCount: number;
  openFilterDrawer: () => void;
}

export const MobileFilterSection: React.FC<MobileFilterSectionProps> = observer(
  ({
    sortBy,
    hasSearchText,
    hasQuestion,
    onSortByChange,
    selectedFilterCount,
    openFilterDrawer,
  }) => {
    const { t } = useTranslations(translations);
    return (
      <Box
        background="surface"
        className={styles.mobileFilterSection}
        width="full"
      >
        <Stack space="medium">
          <Columns space="none">
            <Column>
              <SortOrderDropdown
                sortBy={sortBy}
                hasSearchText={hasSearchText}
                hasQuestion={hasQuestion}
                onSortByChange={onSortByChange}
                align="left"
                trigger={
                  <FilterButton>
                    <SortOrderDropdownTrigger
                      label={t('Sort')}
                      weight="medium"
                      size="small"
                    />
                  </FilterButton>
                }
              />
            </Column>
            <Box className={styles.divider} />
            <Column>
              <FilterActionButton
                selectedFilterCount={selectedFilterCount}
                openFilterDrawer={openFilterDrawer}
              />
            </Column>
          </Columns>
        </Stack>
      </Box>
    );
  },
);
